var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbar-main",staticStyle:{"margin-top":"50px"}})}
var staticRenderFns = []

export { render, staticRenderFns }